import { render, staticRenderFns } from "./SizeDescriptionInfo.vue?vue&type=template&id=5129d627&scoped=true&"
import script from "./SizeDescriptionInfo.vue?vue&type=script&lang=js&"
export * from "./SizeDescriptionInfo.vue?vue&type=script&lang=js&"
import style0 from "./SizeDescriptionInfo.vue?vue&type=style&index=0&id=5129d627&lang=scss&scoped=true&"
import style1 from "./SizeDescriptionInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5129d627",
  null
  
)

export default component.exports